<template>
  <div class="nps-display-graph">
    <div style="display: flex">
      <div class="idx-card-title">
        {{ reportTitle }}
      </div>
      <template v-if="myMetric.indexOf('nps') !== -1">
        <font-awesome-icon
          v-b-modal.modal-info
          class="icon-info"
          :icon="['fas', 'info-circle']"
        />
        <b-modal
          ok-only
          size="xl"
          id="modal-info"
          :title="`${$t('informationAboutNpsDash.aboutNps')}`"
        >
          <div class="row">
            <div class="col-6">
              <label class="range-nps">{{
                $t('informationAboutNpsDash.rangeNps')
              }}</label>
              <p class="reference">
                {{ $t('informationAboutNpsDash.reference') }}
              </p>

              <p class="description">
                <strong>{{ $t('informationAboutNpsDash.awfulTitle') }}</strong>
                {{ $t('informationAboutNpsDash.awful') }}
              </p>

              <p class="description">
                <strong>{{ $t('informationAboutNpsDash.badTitle') }}</strong>
                {{ $t('informationAboutNpsDash.bad') }}
              </p>

              <p class="description">
                <strong>{{ $t('informationAboutNpsDash.goodTitle') }}</strong>
                {{ $t('informationAboutNpsDash.good') }}
              </p>

              <p class="description">
                <strong>{{
                  $t('informationAboutNpsDash.veryGoodTitle')
                }}</strong>
                {{ $t('informationAboutNpsDash.veryGood') }}
              </p>

              <p class="description">
                <strong>{{
                  $t('informationAboutNpsDash.excellentTitle')
                }}</strong>
                {{ $t('informationAboutNpsDash.excellent') }}
              </p>
            </div>
            <div class="col-6">
              <template v-if="this.$i18n.locale === 'br'">
                <img class="size-img" :src="npsInfo" />
              </template>
              <template v-if="this.$i18n.locale === 'us'">
                <img class="size-img" :src="npsInfoEn" />
              </template>
              <template v-if="this.$i18n.locale === 'es'">
                <img class="size-img" :src="npsInfoEs" />
              </template>
            </div>
          </div>
        </b-modal>
      </template>
    </div>
    <div
      class="nps-chart"
      style="display: flex; flex-direction: column; justify-content: center"
    >
      <div v-if="isLoading">
        <idx-skeleton-chart width="10" type="pizza" class="mt-4" />
      </div>
      <div v-else-if="npsValue && amountAnswers !== 0">
        <radial-progress-bar
          v-if="nps !== null && nps !== undefined"
          :diameter="240"
          :stroke-width="20"
          innerStrokeColor="#f1f1f1"
          :startColor="colorBalance"
          :stopColor="colorBalance"
          :completed-steps="completedSteps ? parseFloat(completedSteps) : 0"
          :total-steps="totalSteps"
        >
          <b
            id="number-nps"
            :style="{
              color: colorBalance,
              fontSize: '2.8em',
              fontWeight: 'bold',
            }"
            >{{ completedSteps ? parseFloat(completedSteps).toFixed(1) : 0 }}</b
          >
          <b-tooltip
            v-if="nps !== null && nps !== undefined"
            target="number-nps"
            placement="bottom"
          >
            {{ toolTipMsg }}
            <strong>{{ nps.toFixed(2) }}</strong>
          </b-tooltip>
        </radial-progress-bar>
      </div>
      <div v-else-if="!isLoading && amountAnswers === 0">
        {{ this.$t('reports.npsBar.noData') }}
      </div>
      <div class="avarage" v-if="avarageEnabled && npsValue !== '0'">
        Média das notas: <b>{{ gradeAvarage.toFixed(2) }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import npsInfo from '../../../assets/info-nps.png';
import npsInfoEn from '../../../assets/modal-nps-en.png';
import npsInfoEs from '../../../assets/modal-nps-es.png';
import EventBus from '../../../eventBus';

export default {
  name: 'npsBar',
  components: {
    RadialProgressBar,
    animatedNumber,
    idxSkeletonChart,
  },
  data: () => ({
    userAuth: null,
    completedSteps: null,
    totalSteps: 100,
    colorBalance: '#fff',
    toolTipMsg: '',
    reportTitle: '',
    npsInfo,
    npsInfoEn,
    npsInfoEs,
    isLoading: false,
    npsValue: null,
    gradeAvarage: null,
    avarageEnabled: false,
    qtdInvites: -1,
  }),
  watch: {
    actionGroupData: function watchActionGroup() {

    },
    myActionId: function watchMyActionId() {

    },
    myIh1: function watchMyIh1() {

    },
    myIh2: function watchMyIh2() {

    },

    calendarDates: function watchDates() {
      this.loadMetricValue();
    },
    myMetric: function watchMyMetric() {},
    'indicatorData.value': function watchIndicatorDataValue() {},
    'indicatorData.period': async function watchIndicatorPeriod() {},
  },
  computed: {
    ...mapState('dashboard', ['nps', 'amountInvites', 'amountAnswers']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    ...mapActions('dashboard', ['getMetricValue', 'getNpsByDate']),
    ...mapActions('calendar', ['setDefaultDates']),

    returnOneDecimal(value) {
      return parseFloat(value).toFixed(1);
    },

    loadMetricValue() {
      this.isLoading = true;
      this.getMetricValue({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        // actionId: this.myActionId === '0' ? null : this.myActionId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then((res) => {
        this.gradeAvarage = res.avarage;
        this.avarageEnabled = res.avarageIsActive;

        this.qtdInvites = this.amountInvites;

        this.setColorNps(this.nps);
        if (this.myMetric.indexOf('nps') !== -1) {
          this.completedSteps = this.nps;
        } else if (this.myMetric.indexOf('ces') !== -1) {
          this.completedSteps = this.nps.toFixed(2);
        } else if (this.myMetric.indexOf('csat') !== -1) {
          this.completedSteps = this.nps.toFixed(1);
        } else if (this.myMetric.indexOf('stars') !== -1) {
          this.completedSteps = this.nps.toFixed(1);
        } else if (this.myMetric.indexOf('like-dislike') !== -1) {
          this.completedSteps = this.nps.toFixed(1);
        }
        this.npsValue = this.nps.toFixed(0);
        EventBus.$emit('load-nps');
        this.isLoading = false;
      });
    },
    formatToPrice(value) {
      if (value) {
        return value.toFixed(0);
      }
      return 0;
    },
    setColorNps(percentBalace) {
      if (this.myMetric.indexOf('nps') !== -1) {
        if (percentBalace >= 80) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 80 && percentBalace >= 70) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 70 && percentBalace >= 50) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 50 && percentBalace >= 0) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 0) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('ces') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace <= 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('csat') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('stars') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      }
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.totalSteps = 100;
        this.toolTipMsg = this.$t('reports.npsBar.npsMessage');
        this.reportTitle = this.$t('reports.npsBar.reportTitle');
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.totalSteps = 5;
        this.toolTipMsg = this.$t('reports.npsBar.cesMessage');
        this.reportTitle = this.$t('reports.npsBar.cesReportTitle');
      } else if (this.myMetric === 'csat-1-5') {
        this.totalSteps = 100;
        this.toolTipMsg = this.$t('reports.npsBar.csatMessage');
        this.reportTitle = this.$t('reports.npsBar.csatReportTitle');
      } else if (this.myMetric === 'csat-1-5(media)') {
        this.totalSteps = 5;
        this.toolTipMsg = this.$t('reports.npsBar.csatMessage');
        this.reportTitle = this.$t('reports.npsBar.csatAverageReportTitle');
      } else if (this.myMetric === 'csat-0-10(media)') {
        this.totalSteps = 10;
        this.toolTipMsg = this.$t('reports.npsBar.csatMessage');
        this.reportTitle = this.$t(
          'reports.npsBar.csat0to10AverageReportTitle',
        );
      } else if (this.myMetric === '5-stars') {
        this.totalSteps = 5;
        this.toolTipMsg = this.$t('reports.npsBar.fiveStarsMessage');
        this.reportTitle = this.$t('reports.npsBar.fiveStarsReportTitle');
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        this.totalSteps = 100;
        this.toolTipMsg = this.$t('reports.npsBar.likeDislikeMessage');
        this.reportTitle = this.$t('reports.npsBar.likeDislikeReportTitle');
      }
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  mounted() {
    this.changeLabel();
    this.loadMetricValue();

    EventBus.$on('refresh', async () => {
      // this.setDefaultDates();
      // this.loadMetricValue();
    });

    EventBus.$on('apply-filter-menu', () => {
      this.changeLabel();
      this.loadMetricValue();
    });
    EventBus.$on('reset-filter-menu', () => {
      this.changeLabel();
      this.loadMetricValue();
    });
  },
  beforeDestroy() {
    EventBus.$off('refresh');
    EventBus.$off('apply-filter-menu');
    EventBus.$off('reset-filter-menu');
  },
};

</script>

<style lang="scss">
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.radial-progress-inner {
  justify-content: center;
  font-size: 3.2em;
  cursor: pointer;
}

.nps-display {
  border: 1px solid $gray-light;
  padding: 18px 0;
  flex-direction: column;
  border-radius: 4px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;

  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }

  .nps-chart {
    display: flex;
    margin-bottom: 20px;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
  }
}

.modal-dialog.modal-xl {
  width: 1000px;
  height: 500px;
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.size-img {
  width: 480px;
  height: 320px;
  padding-right: 12px;
  margin-top: 35px;
}

.reference {
  color: #606060;
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 12px;
}

.nps-display-graph {
  border: 1px solid $gray-light;
  padding: 18px 0;
  flex-direction: column;
  border-radius: 4px;
  background-color: $white;
  height: 350px;

  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }

  .nps-chart {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
  }
}

.range-nps {
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
  text-transform: uppercase;
}

.icon-info {
  font-size: 15px;
  color: #c1c1c1;
  margin-left: 15px;
  margin-top: 2px;
  cursor: pointer;
  box-shadow: none;
  margin-right: 20px;
}

.description {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/nps-bar/index.vue